import React, { useEffect, useState, createElement } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
import { industries } from '../data/site';
export function Industries() {
  const [active, setActive] = useState(industries[0]);
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const slug = hash.replace('#', '');
    const found = industries.find(i => i.slug === slug);
    if (found) {
      setActive(found);
      setTimeout(() => {
        document.getElementById('industry-detail')?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    }
  }, [hash]);
  return <>
      <PageHero eyebrow="Industry ready" title="Security designed around how your property actually works." subtitle="Each industry has its own rhythms, risks, and routines. Pick yours to see how Watchdog approaches it." data-id="element-379">
        <CTAButton to="/assessment" data-id="element-380">Free assessment</CTAButton>
      </PageHero>

      <section id="industry-detail" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-381">
        <div className="grid gap-8 lg:grid-cols-[.42fr_.58fr]" data-id="element-382">
          <div className="grid gap-3" data-id="element-383">
            {industries.map(item => {
            const Icon = item.icon;
            const isActive = item.slug === active.slug;
            return <button key={item.slug} onClick={() => setActive(item)} className={`flex items-center gap-4 rounded-3xl border p-5 text-left transition ${isActive ? 'border-sky-300 bg-sky-50 shadow-xl shadow-sky-100' : 'border-slate-200 bg-white hover:bg-slate-50'}`} data-id="element-384">
                  <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${isActive ? 'bg-sky-400 text-slate-950' : 'bg-slate-100 text-slate-600'}`} data-id="element-385">
                    <Icon className="h-6 w-6" data-id="element-386" />
                  </div>
                  <span className="font-black" data-id="element-387">{item.label}</span>
                </button>;
          })}
          </div>

          <motion.div key={active.slug} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} className="rounded-[2rem] bg-slate-950 p-8 text-white shadow-2xl" data-id="element-388">
            <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-3xl bg-sky-400 text-slate-950" data-id="element-389">
              {createElement(active.icon, {
              className: 'h-8 w-8'
            })}
            </div>
            <h3 className="text-3xl font-black tracking-tight" data-id="element-390">
              {active.label}
            </h3>
            <p className="mt-4 text-xl leading-8 text-slate-300" data-id="element-391">
              {active.headline}
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-392">
              {active.points.map(point => <div key={point} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4" data-id="element-393">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-sky-300" data-id="element-394" />
                  <span className="text-sm font-bold text-slate-200" data-id="element-395">
                    {point}
                  </span>
                </div>)}
            </div>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-396">
              <CTAButton to="/assessment" data-id="element-397">
                Free {active.label.toLowerCase()} assessment
              </CTAButton>
              <CTAButton variant="secondary" href="tel:+19168424729" data-id="element-398">
                Call (916) 842-4729
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}